import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlVivero,
  urlViveroSecured,
  urlGetAllViveroSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_VIVERO,
  GET_VIVERO,
  UPDATE_VIVERO,
  DELETE_VIVERO,
  FILTER_VIVERO,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    // if (filters.active !== undefined) filter += '&active=' + filters.active;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get Vivero by uuid.
 */
export const getViveroByUuid = createAction(GET_VIVERO, (param) =>
  apiGet(urlViveroSecured, param, true)()
);

/**
 * Filter list Vivero.
 */
export const filterVivero = createAction(FILTER_VIVERO, (filter, param) =>
  apiGet(urlViveroSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Vivero.
 */
export const createVivero = createAction(CREATE_VIVERO, (obj) =>
  apiPost(urlViveroSecured, obj, undefined, true)()
);

/**
 * Update Vivero.
 */
export const modifyVivero = createAction(UPDATE_VIVERO, (obj, param) =>
  apiPut(urlViveroSecured, obj, param, true)()
);

/**
 * Delete Vivero by uuid.
 */
export const removeVivero = createAction(DELETE_VIVERO, (param) =>
  apiDelete(urlViveroSecured, param, true)()
);

/**
 * Filter list viveros.
 */
export const getAll = createAction("GET_ALL_VIVEROS", (filters) =>
  apiGet(
    urlGetAllViveroSecured + generateFilterQuery(filters),
    undefined,
    false
  )()
);
